/*
 * @Author: pengyong
 * @Date: 2020-11-09 15:57:25
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-14 20:40:04
 * @Description:
 * @FilePath: /exhibit/src/lang/zh.js
 */
export default {
    locale: 'zh',
    header:{
        exhibitor: '展商',
        info: '简介',
        exhibits: '展品',
        video: '视频',
        home: '首页',
        pavilion: '展馆',
        exhibition: '展会',
        review: '回顾',
        search_exhibitor: '正在搜索 展商 〉 “搜索的关键词”',
        area_selection:'地区选择',
        place:'地点',
        start_time:'开展日期',
        search_goods: '正在搜索 展品 〉 “搜索的关键词”:',
        review_tip:'暂无回顾',
        choose_role: '请选择',
        choose_exhibition: '请输入搜索展商内容',
        choose_goods:'请输入搜索展品内容',
        my: '我的',
        headertitle: '全球数字贸易云展会平台',
        is_search_exhibitor: '正在搜索',
        empty_tip: '赶快搜索查看更多精彩内容吧！',
        template_tip: '暂无内容敬请期待'
    },
    "personalCenter": {
        "exhibitorStore": '展商收藏',
        'noExhibitor': '暂无展商',
        'search': '搜索',
        'exhibitsStore': '展品收藏',
        'noExhibits': '暂无展品',
        'exhibitis': '展品',
        'exhibitor': '展商',
        'baseInfo': '基本资料',
        'name': '姓名',
        'gender': '性别',
        'male': '男',
        'female': '女',
        'country': '国家/地区',
        'companyName': '公司名称',
        'email': '邮箱',
        'nickName': '昵称',
        'interest': '意向产品',
        'save': '保存',
        'passModify': '修改密码',
        'oldPassword': '原密码',
        'newPassword': '新密码',
        'passwordRepeat': '重复新密码',
        "passwordTip": '密码设置为8位以上的英文字母、数字、特殊字符至少三种组合',
        "oldPassPlaceholder": '请输入原密码'
     },
    exhibition: {
        pavilion: '所有展馆',
        hold: '正在举办',
        ready: '展会回顾',
        start_time:'开展日期',
        place: '地点',
        exhibitor: '展商',
        live: '会议系统',
        living_tip: '正在举办中的会议',
        living: '日本站-水产品专场',
        is_opening: '现已开放'
    },
    zhanqu: {
        allExh: '所有展商'
    },
    about: {
        h2: "基本信息",
        msg1: "注册资本",
        msg2: "企业规模",
        msg3: "公司官网",
        msg4: "主营产品",
        msg5: "主要销售范围"
    },
    videoList: {
        h1: "视频列表",
        video: "视频"
    },
    contact: {
        msg1: "联系人",
        msg2: "联系人电话",
        msg3: "联系人邮箱",
        msg4: "企业电话",
        msg5: "企业邮箱",
        msg6: "网址",
        msg7: "企业地址"
    },
    card: {
        h1: "提示",
        msg: "点击确认代表您同意与该展商交换名片,您的名片信息(姓名、电话等)将共享给该展商,方便展商与您取得联系,请确认是否同意?",
        noCaution: "不再提醒",
        btn1: "再想想",
        btn2: "同意",
        contact: '联系方式'
    },
    detail: {
        collect: "收藏",
        uncollect: "取消",
        parameter: "产品参数",
        msg1: "产品价格：",
        msg2: "品牌名称：",
        msg3: "产品型号：",
        msg4: "产品规格：",
        msg5: "主要技术参数：",
        introduction: "产品简介"
    },
    conference: {
        bigconference: "论坛区",
        smallconference: "路演区"
    },
    smallconference: {
        left: ["活动议程"],
        right: ["嘉宾介绍", "企业介绍"]
    },
    bigconference: {
        left: ["会议议程"],
        right: ["嘉宾介绍", "企业介绍"]
    },
    area: {
        left: ["展台简介", "视频列表", "产品介绍"],
        right: ["联系方式", "名片交换", "在线洽谈"],
        searchPld: "请输入企业名称",
        searchNodata: "抱歉,未搜索到相关结果,请尝试其他关键词",
        loginTip: "请先登录",
        noData: "暂无内容"
    },
    userInfo: {
        h1: "基本资料",
        zh: "账号",
        gj: "国家/地区",
        name: "姓名",
        gs: "公司",
        yxcp: "意向产品",
        bc: "保存"
    },
    amendPassword: {
        msg1: "原密码",
        msg2: "新密码",
        msg3: "确认新密码",
        bc: "保存",
        msg1Placeholder: "请输入原密码",
        msg2Placeholder: "请输入新密码",
        msg3Placeholder: "请再次输入新密码",
        error: "两次输入密码不一致",
        tip: "密码设置为8位以上的英文字母、数字、特殊字符至少三种组合"
    },
    agenda: {
      title: "日程安排"
    },
    consult: {
        title: "联系我们",
        name: "姓名",
        gj: "国家/地区",
        yx: "邮箱",
        tell: "联系电话",
        wenti: "我的问题",
        tj: "提交",
        noName: "请输入姓名",
        noCountry: "请选择地区",
        noMail: "请输入邮箱",
        noPhone: "请输入手机号",
        success: "提交成功"
    },
    areaIndex: {
        zxt: "咨询台",
        zlt: "展览厅",
        hyt: "会议厅",
        mpj: "名片夹",
        scj: "收藏夹",
        rc: "日程",
        home: '首页'
    },
    exhibit: {
        yun: "云展会",
        about: "关于我们",
        login: "登录 | 注册",
        user: "个人中心",
        exit: "退出"
    },
    role: {
        gzTitle: "我是观众",
        gzDesc: "观众登录入口，进行线上云展会参观",
        zsTitle: "我是展商",
        zsDesc: "参展企业登录入口，进入参展商后台管理系"
    },
    login: {
        audienceLogin: "登录云展会",
        exhibitorLogin: "登录展商管理后台",
        login: "登录",
        accountLogin: "账户密码登录",
        phoneLogin: "手机号登录",
        emailLogin: "邮箱登录",
        accountPlaceHolder: "请输入账号",
        pswPlaceHolder: "请输入密码",
        phonePlaceholder: "请输入手机号",
        emailPlaceholder: "请输入邮箱",
        codePlaceholder: "请输入验证码",
        sendCode: "发送验证码",
        autoLogin: "自动登录",
        forget: "忘记密码",
        tip: "还没账号？去",
        registerTip: "注册",
        imgPlaceHolder: "图形验证码",
        login_out: '已退出登录',
        confirm_logout: '确定退出登录吗?',
        tip: '提示',
        confirm: '确定',
        cancel: '取消'
    },
    register: {
        register: "注册",
        phoneReg: "手机号注册",
        emailReg: "邮箱注册",
        countryPlaceholder: "国家/地区",
        namePlaceholder: "姓名(请输入真实姓名)",
        companyPlaceholder: "公司名称(请输入公司名称)",
        productPlaceholder: "意向产品(请输入意向产品名称)",
        pswPlaceholder: "请设置密码6~18位，包含大小写英文字母、数字、特殊字符至少3种",
        tip: "已有账号，去",
        loginTip: "登录"
    },
    userCenter: {
        collect: "收藏夹",
        collectVideo: "视频收藏",
        collectZp: "展品收藏",
        collectFile: "文件收藏",
        collectExhibitors: '展商收藏',
        card: "名片夹",
        accountInfo: "账户信息",
        baseInfo: "基本资料",
        modifyPsw: "密码修改",
        logout: "注销登录",
        exit: "退出",
        cardTitle: "我的名片",
        name: "姓名",
        account: "账号",
        company: "公司名称",
        editCard: "编辑名片",
        zhiwei: "职位",
        elecCard: "上传电子名片",
        save: "保存",
        inputPlaceholder: "请输入",
        video: "视频",
        delet: "删除",
        play: "播放",
        email: "邮箱:",
        address: "地址:",
        exhibition: "展会:",
        edit: "编辑",
        del: "删除",
        chooseAll: "全选",
        chooseAllCancel: "取消全选",
        cancel: "取消",
        phone: "电话",
        post: "职位",
        save: "保存"
    },
    forget: {
        title: "选择找回密码的方式",
        byEmail: "通过注册邮箱找回密码",
        byPhone: "通过注册手机号找回密码",
        title2: "验证身份",
        phonePlaceHolder: "请输入注册时使用的手机号",
        pswPlaceHolder: "请输入新密码",
        newPswPlaceHolder: "请再次输入新密码",
        submit: "提交",
        title3: "设置完成",
        successTitle: "恭喜您修改密码成功!",
        successDesc: "10秒后自动跳转到登录界面,您也可以通过点击下方的完成按钮手动页面登录",
        complete: "完成"
    },
    chat: {
        pld: "请输入文字开始对话吧"
    },
    tips: {
        noSchedule: "敬请期待",
        noVideo: "暂无视频",
        noProduct: "暂无产品",
        noCollect: "空空如也，赶紧去收藏吧！",
        noCard: "空空如也，赶紧去交换名片吧！",
        noLive: "直播未开始"
    },
    contactUsTips: {
      EDUCATION: {
        message: '我们将为您参加2020浙江服务贸易云展会（全球数字贸易博览会专场）提供优质服务，请填写反馈表单或直接与我们联系，以取得更多信息和建议。 您也可以通过电话或邮箱直接联系我们哦~',
        workTime: '工作时间：周一至周五8：30-17：30',
        phone: '电话：+86 571 87297482'
      },
      TRADE: {
        message: '我们将为您参加2020浙江服务贸易云展会（全球数字贸易博览会专场）提供优质服务，请填写反馈表单或直接与我们联系，以取得更多信息和建议。 您也可以通过电话或邮箱直接联系我们哦~    ',
        workTime: '工作时间：周一至周五8：30-17：30',
        phone: '电话：+86 571 87297482'
      }
    },
    myCard:{
        save_tip: '上传成功，请点击保存',
        img_format: '只支持图片格式',
        img_size: '图片大小不超过2MB',
        save_success: '保存成功'
    }
};



// WEBPACK FOOTER //
// ./src/lang/zh.js